import {
  Accordion as MuiAccordion,
  AccordionActions as MuiAccordionActions,
  type AccordionActionsProps as MuiAccordionActionsProps,
  AccordionDetails as MuiAccordionDetails,
  type AccordionDetailsProps as MuiAccordionDetailsProps,
  type AccordionProps as MuiAccordionProps,
  AccordionSummary as MuiAccordionSummary,
  type AccordionSummaryProps as MuiAccordionSummaryProps,
} from "@mui/material";

export type AccordionProps = MuiAccordionProps;
export type AccordionActionsProps = MuiAccordionActionsProps;
export type AccordionDetailsProps = MuiAccordionDetailsProps;
export type AccordionSummaryProps = MuiAccordionSummaryProps;

export const Accordion = MuiAccordion;
export const AccordionActions = MuiAccordionActions;
export const AccordionDetails = MuiAccordionDetails;
export const AccordionSummary = MuiAccordionSummary;
